import { Button, HStack, IconButton, Text } from "@chakra-ui/react"
import { Form, Parts, UI } from "components"
import { toaster } from "config"
import { API } from "config"
import { useState } from "react"

export default function Third(){
    
    const [ loading, setLoading ] = useState(false)
    const [ error, setError ] = useState()
    const [ cod, setCod ] = useState()
    const [ order, setOrder ] = useState()

    const handleChange = (value) => {
        setCod(value)
        setError(null)
    }

    const handleSubmit = async () => {
        if(!cod || cod?.length < 5) return
        setLoading(true)
        setError(null)

        try{
            const callback = await API.get(`/third/${cod}`)
            setOrder(callback.data)
            setCod(null)
            toaster.create({ title: 'Pedido encontrado' })
        }catch(err){
            setError(err?.response?.data?.message)
            toaster.create({ title: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Parts.Dialog.Third.Pay open={!!order} data={order} onClose={() => setOrder(false)} />
    <UI.Box>
        <Text fontSize="md" fontWeight="bold" color="blue.fg"><UI.Icon name="check" /> Pagamento de terceiros</Text>
        <Text fontSize="sm" color="GrayText">Insira abaixo o código do pedido para realizar o pagamento:</Text>
    
        <Form.Container mt={4} autocomplete="off" onSubmit={handleSubmit}>
        
            <HStack>
                <Form.Text
                    required
                    placeholder="Ex.: PED12345"
                    size="lg"
                    fontWeight="bold"
                    minLength="5"
                    maxLength="12"
                    textTransform="uppercase"
                    value={cod}
                    onChange={e => handleChange(e.target.value)}
                    disabled={loading}
                    error={error}
                    colorPalette="blue"
                />
                <IconButton type="submit" colorPalette="blue" mt={-2} disabled={!cod || cod?.length < 5} loading={loading}><UI.Icon name="search" /></IconButton>
            </HStack>

            <UI.Alert size="sm" colorPalette="info">
                Você precisa ter saldo suficiente e o cliente deve ter selecionado a opção de "Pagamento de Terceiros".
            </UI.Alert>

        </Form.Container>
    </UI.Box>
    </>
    )
}